// Custom formats for each language. These are based on the internal formats defined by moment.js
//  To see the list of formats, run the following snippet: (don't worry about the typescript error).
//
// import moment from "moment";
// serverReference.interfaceCultures.forEach(culture => {
//   moment.locale(culture.locale);
//   const m = moment.utc();
//   console.log("Culture:", culture.locale);
//   console.log(moment.localeData()._longDateFormat)
// });

type CustomMomentFormat = {
  "nl-BE": string
  "nl-NL": string
  "en-GB": string
  "en-US": string
  "en-IE": string
  "de-DE": string
  "it-IT": string
  "es-ES": string
  "pt-BR": string
  "pt-PT": string
}

const momentLocaleToCultureLocale: { [momentLocale: string]: keyof CustomMomentFormat } = {
  "nl-be": "nl-BE",
  "nl": "nl-NL",
  "en-gb": "en-GB",
  "en-ie": "en-IE",
  "en": "en-US",
  "de": "de-DE",
  "it": "it-IT",
  "es": "es-ES",
  "pt-br": "pt-BR",
  "pt": "pt-PT"
}

export const customFormat = (m: moment.Moment, format: CustomMomentFormat): string => {
  const cultureLocale = momentLocaleToCultureLocale[m.locale()];
  return m.format(format[cultureLocale]);
}

export const DayOfWeekDayShort: CustomMomentFormat = {
  "nl-BE": "ddd D",
  "nl-NL": "ddd D",
  "en-GB": "ddd, D",
  "en-IE": "ddd, D",
  "en-US": "ddd, D",
  "de-DE": "ddd, D.",
  "it-IT": "ddd D",
  "es-ES": "ddd, D",
  "pt-BR": "ddd, D",
  "pt-PT": "ddd, D",
}

export const DayOfWeekMonthDayShort: CustomMomentFormat = {
  "nl-BE": "ddd D MMM",
  "nl-NL": "ddd D MMM",
  "en-GB": "ddd, D MMM",
  "en-US": "ddd, MMM D",
  "en-IE": "ddd, D MMM",
  "de-DE": "ddd, D. MMM",
  "it-IT": "ddd D MMM",
  "es-ES": "ddd, D [de] MMM",
  "pt-BR": "ddd, D [de] MMM",
  "pt-PT": "ddd, D [de] MMM",
}

export const DayOfWeekMonthDayYear: CustomMomentFormat = {
  "nl-BE": "ddd D MMMM YYYY",
  "nl-NL": "ddd D MMMM YYYY",
  "en-GB": "ddd, D MMMM YYYY",
  "en-IE": "ddd, D MMMM YYYY",
  "en-US": "ddd, MMMM D, YYYY",
  "de-DE": "ddd, D. MMMM YYYY",
  "it-IT": "ddd D MMMM YYYY",
  "es-ES": "ddd, D [de] MMMM [de] YYYY",
  "pt-BR": "ddd, D [de] MMMM [de] YYYY",
  "pt-PT": "ddd, D [de] MMMM [de] YYYY",
}

export const DayOfWeekMonthDayYearShort: CustomMomentFormat = {
  "nl-BE": "ddd D MMM YYYY",
  "nl-NL": "ddd D MMM YYYY",
  "en-GB": "ddd, D MMM YYYY",
  "en-IE": "ddd, D MMM YYYY",
  "en-US": "ddd, MMM D, YYYY",
  "de-DE": "ddd, D. MMM YYYY",
  "it-IT": "ddd D MMM YYYY",
  "es-ES": "ddd, D [de] MMM [de] YYYY",
  "pt-BR": "ddd, D [de] MMM [de] YYYY",
  "pt-PT": "ddd, D [de] MMM [de] YYYY",
}